import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isDevFeatureEnabled } from '../../../constants/dev';
import { isEmpoweredManager as isEmpoweredManagerSelector } from '../../../redux/modules/user/selectors';
import { useIsFeatureEnabled } from '../../feature-enablement/featureEnablement';
import {
  type QueueSettingsPage,
  queueSettingsPages,
} from '../fields/constants';

export const EMPOWERED_MANAGER_QUEUE_SETTINGS_PAGES = [
  'automation',
  'access',
  'rules',
] as const satisfies readonly QueueSettingsPage[];

export const getVisibleQueueSettingsPages = ({
  configMapEnabled,
  isEmpoweredManager,
  isEditModeSettingsEnabled,
}: {
  configMapEnabled: boolean;
  isEmpoweredManager: boolean;
  isEditModeSettingsEnabled: boolean;
}) =>
  queueSettingsPages.filter(page => {
    if (isEmpoweredManager) {
      return EMPOWERED_MANAGER_QUEUE_SETTINGS_PAGES.some(
        allowed => allowed === page
      );
    }

    if (page === 'overview') return configMapEnabled;
    if (page === 'edit') return isEditModeSettingsEnabled;

    return true;
  });

export const useVisibleQueueSettingsPages = () => {
  const configMapEnabled = useIsFeatureEnabled('configuration-map');
  const empoweredManager = useSelector(isEmpoweredManagerSelector);
  const isEditModeSettingsEnabled = !!isDevFeatureEnabled('edit-mode-settings');

  return useMemo(
    () =>
      getVisibleQueueSettingsPages({
        configMapEnabled,
        isEmpoweredManager: empoweredManager,
        isEditModeSettingsEnabled,
      }),
    [configMapEnabled, empoweredManager, isEditModeSettingsEnabled]
  );
};
